import type { Epic } from 'Flux/index.js'
import { organizationSlice } from 'Flux/Slice/Organization/OrganizationSlice.js'
import { authenticationExpiredOr } from 'Framework/Epic/AuthenticationExpired.js'
import { catchError, filter, mergeMap, of } from 'rxjs'
import type { AjaxError } from 'rxjs/ajax'

export const GetOrganizationEpic: Epic = (action$, state$, { [organizationSlice.name]: organization, OrganizationRepository }) =>
  action$.pipe(
    filter(organization.getOrganizationRequest.match),
    mergeMap((action) => {
      return OrganizationRepository.getOrganization({ organizationId: action.payload.organizationId }).pipe(
        mergeMap((response) => of(organization.getOrganizationSuccess({ organization: response }))),
        catchError((error: AjaxError) =>
          authenticationExpiredOr({
            error,
            failedRequest: action.type,
            failureAction: of(organization.getOrganizationFailure({ error }))
          })
        )
      )
    })
  )
